import { render } from "./TeamBalanceSheets.vue?vue&type=template&id=05496cf7"
import script from "./TeamBalanceSheets.vue?vue&type=script&lang=js"
export * from "./TeamBalanceSheets.vue?vue&type=script&lang=js"

import "./TeamBalanceSheets.vue?vue&type=style&index=0&id=05496cf7&lang=scss"
script.render = render

export default script